import { useState } from 'react'
import { useAchievementsStore } from '@/store/achievementsStore'
import { ACHIEVEMENTS, AchievementCategory } from '@/config/achievementsConfig'
import { BroadcastHeader, MedalIcon } from '../components/broadcast'
import { CircleHelp } from 'lucide-react'

const CATEGORIES: { id: AchievementCategory | 'all'; label: string }[] = [
  { id: 'all', label: 'Todos' },
  { id: 'construction', label: 'Construcción' },
  { id: 'economy', label: 'Economía' },
  { id: 'customers', label: 'Clientes' },
  { id: 'staff', label: 'Personal' },
  { id: 'time', label: 'Tiempo' },
  { id: 'special', label: 'Especial' },
]

export function AchievementsTabContent() {
  const [category, setCategory] = useState<AchievementCategory | 'all'>('all')
  const { unlockedAchievements, getProgress, isUnlocked } = useAchievementsStore()

  const filtered = category === 'all'
    ? ACHIEVEMENTS
    : ACHIEVEMENTS.filter(a => a.category === category)

  const visibleTotal = ACHIEVEMENTS.filter(a => !a.isSecret || isUnlocked(a.id)).length
  const goldCount = ACHIEVEMENTS.filter(a => a.tier === 'gold' && isUnlocked(a.id)).length

  return (
    <div>
      <BroadcastHeader
        title="Vitrina de medallas"
        competition="Palmarés del club"
        meta={
          <>
            <span className="chip-angled tone-gold">{unlockedAchievements.length}/{visibleTotal} conseguidas</span>
            {goldCount > 0 && <span className="chip-angled">{goldCount} de oro</span>}
          </>
        }
      />

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.35rem', marginBottom: '1rem' }}>
        {CATEGORIES.map(cat => (
          <button
            key={cat.id}
            onClick={() => setCategory(cat.id)}
            className={`chip-angled${category === cat.id ? ' tone-gold' : ''}`}
            style={{ cursor: 'pointer', border: 'none', padding: '0.3rem 0.8rem' }}
          >
            {cat.label}
          </button>
        ))}
      </div>

      <div className="medal-grid">
        {filtered.map(achievement => {
          const unlocked = isUnlocked(achievement.id)
          const isSecret = achievement.isSecret && !unlocked
          const progress = getProgress(achievement)

          return (
            <div
              key={achievement.id}
              className={`medal-card ${unlocked ? 'unlocked tx-glass-sheen' : 'locked'}`}
            >
              {isSecret ? (
                <span
                  style={{
                    width: 56,
                    height: 56,
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '50%',
                    background: 'var(--fill-soft)',
                    border: '1.5px dashed var(--border-default)',
                    color: 'var(--text-muted)',
                  }}
                >
                  <CircleHelp size={24} />
                </span>
              ) : (
                <MedalIcon tier={achievement.tier} size={56} locked={!unlocked} />
              )}

              <div className="medal-card-name">{isSecret ? 'Logro secreto' : achievement.name}</div>
              <div className="medal-card-desc">
                {isSecret ? 'Sigue jugando para descubrirlo' : achievement.description}
              </div>

              {!isSecret && achievement.reward?.money && (
                <div className="medal-card-reward">+{achievement.reward.money.toLocaleString('es-ES')}€</div>
              )}

              {!unlocked && !isSecret && progress > 0 && (
                <div className="progress-track" style={{ width: '100%' }}>
                  <div className="progress-fill angled" style={{ width: `${progress}%` }} />
                </div>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}
